<template lang="pug">
table.table.table-lesson(:class='tableClass')
  thead
    tr(style="text-align: left; font: Bold 15px/17px Helvetica; letter-spacing: 0px; color: #343A40; opacity: 1;")
      th(v-for='c in columns', :key='c.title') {{c.title}}
  tbody
    tr(v-if='this.inlineFilter === true', style="background: #EAEAEA 0% 0% no-repeat padding-box; opacity: 1;")
      td(v-if='this.inlineVideo === true')
      td
      td
        input#name(@change="onnameChange($event)" placeholder="Tìm theo tên" style="background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 5px; opacity: 1; padding: 5px;")
      td(v-if='this.inlineCategory !== true')
        select#category_id(@change="oncategoryChange($event)" style="background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 5px; opacity: 1; padding: 6px;")
          option( value='') Tất cả
          option(v-for='o in filterCategory' :value='o.id') {{o.name}}
      td(v-if='this.inlineCategory !== true')
        select#subject_id(@change="onsubjectChange($event)" style="background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 5px; opacity: 1; padding: 6px;")
          option( value='') Tất cả
          option(v-for='o in filterSubjects' :value='o.id') {{o.name}}
      td(v-if='this.inlineCategory !== true')
        select#grade_id(@change="ongradeChange($event)" style="background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 5px; opacity: 1; padding: 6px;")
          option( value='') Tất cả
          option(v-for='o in filterGrades' :value='o.id') {{o.name}}
      td(v-if='this.inlineCategory === true')
      td(v-if='this.inlineCategory === true')
      td(v-if='this.inlineCategory === true')
      td(v-if='this.inlineCategory === true')
      td
      td
      td
    tr(v-if='this.data.length === 0', style='white-space: nowrap;')
      td(:colspan="columns.length")
        span Không có dữ liệu
    tr(v-else v-for='item in data' v-bind:id="'row' + item.id")
      td(v-for='c in columns')
        span(v-if='hasValue(item, c) && !isVideoCount(c) && !isLessonCount(c)', v-html='itemValue(item, c)')
        a(v-if='hasValue(item, c) && isVideoCount(c)', v-html='itemValue(item, c)', v-on:click="toVideo(item)", style="cursor: pointer")
        a(v-if='hasValue(item, c) && isLessonCount(c)', v-html='itemValue(item, c)', v-on:click="toLesson(item)", style="cursor: pointer")
        span(v-if='isAction(c)')
          i.material-icons.text-gray.list-action(v-on:click="editItem(item)") edit
          i.material-icons.text-gray.list-action(v-on:click="deleteItem(item)") delete
        span(v-if='isCustom(c)', v-bind:id='itemValue(item, c)')
          i.material-icons.text-gray(style="cursor:pointer") more_horiz
          b-popover(:target="itemValue(item, c)" triggers="hover" placement="top") 
            template
              div(style="width: 110px; height: 135px; background: #E0E0E0 0% 0% no-repeat padding-box;box-shadow: 0px 1px 0px #00000029;opacity: 1;")
                div.editlesson(v-on:click="editItem(item)" style="cursor:pointer; padding-top: 10px; padding-left: 10px; padding-right: 10px; text-align: left;font: Regular 15px/18px Proxima Nova;letter-spacing: 0px;color: #23180A;opacity: 1;") Chỉnh sửa
                div.viewlesson(v-on:click="viewItem(item)" style="cursor:pointer; padding-top: 10px; padding-left: 10px; padding-right: 10px; text-align: left;font: Regular 15px/18px Proxima Nova;letter-spacing: 0px;color: #23180A;opacity: 1;") Chế độ xem
                div.deletelesson(v-on:click="deleteItem(item)" style="cursor:pointer; padding-top: 10px; padding-left: 10px; padding-right: 10px; padding-bottom: 10px; text-align: left;font: Regular 15px/18px Proxima Nova;letter-spacing: 0px;color: #23180A;opacity: 1;") Xóa
                div.publiclesson(v-if="item.is_public === 1" style="cursor:pointer; border-top: 0.5px solid #B4B4B4; padding-top: 5px; padding-left: 10px; padding-right: 10px; text-align: left;font: Regular 15px/18px Proxima Nova;letter-spacing: 0px;color: #23180A;opacity: 1;") Chưa hiển thị
                div.publiclesson(v-if="item.is_public === 2" style="cursor:pointer; border-top: 0.5px solid #B4B4B4; padding-top: 5px; padding-left: 10px; padding-right: 10px; text-align: left;font: Regular 15px/18px Proxima Nova;letter-spacing: 0px;color: #23180A;opacity: 1;") Đang public
                div.publiclesson(v-if="item.is_public === 3" style="cursor:pointer; border-top: 0.5px solid #B4B4B4; padding-top: 5px; padding-left: 10px; padding-right: 10px; text-align: left;font: Regular 15px/18px Proxima Nova;letter-spacing: 0px;color: #23180A;opacity: 1;") Trong PC
</template>

<script>
import moment from 'moment'
import $ from 'jquery'

export default {
  name: 'md-table',
  props: {
    columns: Array,
    data: Array,
    actions: Array,
    type: {
      type: String, // default | striped | hover
      default: ''
    },
    inlineFilter: {
      type: Boolean,
      default: false
    },
    inlineVideo: {
      type: Boolean,
      default: false
    },
    inlineCategory: {
      type: Boolean,
      default: false
    },
    filterCategory: Array,
    filterSubjects: Array,
    filterGrades: Array
  },
  computed: {
    tableClass() {
      return `table-${this.type}`
    }
  },
  mounted () {
    if (this.$route.params.category_id !== undefined) {
      // console.log('cccc', this.$route.params.category_id)
      $('select#category_id').val(this.$route.params.category_id)
      this.$emit('onfilterbycategory', this.$route.params.category_id)
    }
  },
  methods: {
    editItem(item) {
      // console.log('Edit Item ' + item.id)
      this.$emit('onItemEdit', item)
    },
    toVideo(item) {
      this.$emit('onToVideo', item)
    },
    toLesson(item) {
      this.$emit('onToLesson', item)
    },
    viewItem(item) {
      // console.log('Edit Item ' + item.id)
      this.$emit('onItemView', item)
    },
    deleteItem(item) {
      // console.log('Delete Item ' + item.id)
      this.$emit('onItemDelete', item)
    },
    hasValue(item, col) {
      if (col.type === 'action' || item[col.key] === 'undefined' || col.type === 'custom') {
        return false
      } else {
        return true
      }
    },
    fmDate(item, col) {
      return moment(item[col.key]).format('DD/MM/YYYY hh:mm')
      // var d = new Date(item[col.key])
      // var day = ('0' + d.getDate()).slice(-2)
      // var month = ('0' + (d.getMonth() + 1)).slice(-2)
      // var year = d.getFullYear()
      // var hour = ('0' + d.getHours()).slice(-2)
      // var minute = ('0' + d.getMinutes()).slice(-2)
      // return day + '/' + month + '/' + year + ' ' + hour + ':' + minute
    },
    isAction(col) {
      if (col.type === 'action') return true
      else return false
    },
    isVideo(col) {
      if (col.type === 'video') return true
      else return false
    },
    isVideoCount(col) {
      if (col.type === 'video_count') return true
      else return false
    },
    isLessonCount(col) {
      if (col.type === 'lesson_count') return true
      else return false
    },
    isCustom(col) {
      if (col.type === 'custom') return true
      else return false
    },
    itemValue(item, column) {
      var value = item[column.key]
      if (column.type) {
        if (column.type === 'image') {
          return '<img src="' + value + '" style="width:30px"/>'
        } else if (column.type === 'date') {
          return this.fmDate(item, column)
        } else if (column.type === 'custom') {
          return value
        } else if (column.type === 'video') {
          return '<video src="' + value + '" style="width:150px; height: 90px" controls /></video>'
        } else if (column.type === 'video_count') {
          return value.aggregate.count
        } else if (column.type === 'lesson_count') {
          return value.aggregate.count
        } else if (column.type === 'created_user' || column.type === 'updated_user') {
          return value.fullname
        }
      } else {
        if (typeof value === 'object') return value.name
        return value
      }
    },
    onnameChange(event) {
      // console.log(event.target.value)
      this.$emit('onfilterbyname', event.target.value)
    },
    oncategoryChange(event) {
      // console.log(event.target.value)
      this.$emit('onfilterbycategory', event.target.value)
    },
    onsubjectChange(event) {
      // console.log(event.target.value)
      this.$emit('onfilterbysubject', event.target.value)
    },
    ongradeChange(event) {
      // console.log(event.target.value)
      this.$emit('onfilterbygrade', event.target.value)
    }
  }
}

</script>
<style lang="scss">
.list-action {
  cursor: pointer;
}
.popover.b-popover {
    display: block;
    opacity: 1;
    outline: 0;
}
.popover {
    top: 0;
    left: 0;
    z-index: 1060;
    max-width: 276px;
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    word-spacing: normal;
    white-space: normal;
    line-break: auto;
    // font-size: .875rem;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0,0,0,.2);
    border-radius: .3rem;
}
.deletelesson:hover {
  color: red !important;
}
.editlesson:hover {
  color: blue !important;
}
.viewlesson:hover {
  color: blue !important;
}
.publiclesson:hover {
  color: green !important;
}
.table-lesson {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// index.vue?a89cb47c